import React from 'react';
import { CheckIcon, ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { guaranteeItems } from '../../data/salesCopy';
export function GuaranteeSection() {
  return <section className="w-full bg-paper px-5 py-16 sm:py-24" data-id="element-196" data-mp="1kb2hq5n3xt9i">
      <div className="mx-auto max-w-5xl rounded-[2rem] bg-white p-6 shadow-sm ring-1 ring-slate-200 sm:p-12" data-id="element-197" data-mp="1fcsmjv1dusnw">
        <div className="grid items-center gap-8 md:grid-cols-[auto_1fr] md:gap-12" data-id="element-198" data-mp="1adg1nfu2nvny">
          <div className="mx-auto flex h-44 w-44 flex-col items-center justify-center rounded-full bg-navy-900 text-center ring-8 ring-brand/25" data-id="element-199" data-mp="1abbpybpxlsd4">
            <ShieldCheckIcon className="h-12 w-12 text-brand" aria-hidden="true" data-id="element-200" data-mp="11e1asf9ztj2x" />
            <span className="mt-1 font-display text-5xl font-black leading-none text-white" data-id="element-201" data-mp="weopw02omm2z">7</span>
            <span className="font-display text-sm font-bold uppercase tracking-widest text-slate-300" data-id="element-202" data-mp="2vrapclhebus1">Day guarantee</span>
          </div>

          <div className="text-center md:text-left" data-id="element-203" data-mp="2qspnkhmhx31h">
            <p className="font-display text-base font-bold uppercase tracking-[0.12em] text-brand-dark sm:text-lg" data-id="element-204" data-mp="1g4bwe403imhn">
              Your purchase is protected by a 7-day guarantee
            </p>
            <h2 className="mt-2 text-balance font-display text-4xl font-extrabold uppercase leading-[0.98] text-ink sm:text-5xl" data-id="element-205" data-mp="174oulh3gfeo2">
              Explore the Material Before You Decide
            </h2>
            <p className="mt-4 text-lg leading-relaxed text-slate-700" data-id="element-206" data-mp="1zsaxen4uyf9v">
              I want you to have the opportunity to review the collection and decide whether it fits your educational needs. Your purchase is
              covered by a seven-day money-back guarantee.
            </p>
          </div>
        </div>

        <div className="mt-10 grid gap-8 md:grid-cols-2" data-id="element-207" data-mp="1v12n7ovpepvn">
          <div data-id="element-208" data-mp="2irovnh9mec66">
            <p className="font-display text-lg font-bold uppercase text-ink" data-id="element-209" data-mp="2iryk30f0ob9r">After purchasing, you can:</p>
            <ul className="mt-3 space-y-2.5" data-id="element-210" data-mp="2nix7sl2c4bn1">
              {guaranteeItems.map(item => <li key={item} className="flex items-start gap-2.5 text-base text-slate-800" data-id="element-211" data-mp="2xexd2ztivdql">
                  <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-emerald-600" strokeWidth={3} aria-hidden="true" data-id="element-212" data-mp="2sfkh9pkoawbv" />
                  {item}
                </li>)}
            </ul>
          </div>
          <p className="self-center rounded-2xl bg-paper p-5 text-base leading-relaxed text-slate-700" data-id="element-213" data-mp="2ihwimojy54of">
            If you decide within seven days that the collection isn’t right for you, contact us within the guarantee period to request a refund in
            accordance with the published refund policy.
          </p>
        </div>
      </div>

      <CtaButton label="Get Access and Explore the Collection" sub="One-time payment of $27 · Instant access" data-id="element-214" data-mp="24pzx53cs9t10" />
    </section>;
}